import { render } from "./VGeneralModal.vue?vue&type=template&id=38040e70&scoped=true&ts=true"
import script from "./VGeneralModal.vue?vue&type=script&lang=ts"
export * from "./VGeneralModal.vue?vue&type=script&lang=ts"

import "./VGeneralModal.vue?vue&type=style&index=0&id=38040e70&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38040e70"]])

export default __exports__